import { TeamMember } from './skillz-team.interface';

export const skillzTeamData: TeamMember[] = [
  {
    name: 'Hilde',
    role: $localize`Founder Skillz`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Hilde.jpg',
  },
  {
    name: 'Jelle',
    role: $localize`Founder Skillz`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Jelle.jpg',
  },
  {
    name: 'Jorre',
    role: $localize`Logistics`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Jorre.jpg',
  },
  {
    name: 'Jolan',
    role: $localize`Workshops`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Jolan.jpg',
  },
  {
    name: 'Greet',
    role: $localize`After school courses / Camps with overnight stay`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Greet.jpg',
  },
  {
    name: 'Aurélie',
    role: $localize`Camps without overnight stay`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Aurelie.jpg',
  },
  {
    name: 'Hanne',
    role: $localize`Educational manager`,
    image:
      'https://skillz.blob.core.windows.net/images/prismarine/team/Hanne.jpg',
  },
];
